import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Badge, IconButton, Menu, MenuItem } from "@mui/material";
import { FiBell, FiMenu, FiUser, FiUsers } from "react-icons/fi";
import { useSoftUIController, setMiniSidenav } from "context";
import { useAuth } from "context/AuthContext";
import { useNotification } from "context/NotificationContext";
import routes from "routes";

export default function DashboardNavbar({ isMini = false }) {
  const [controller, dispatch] = useSoftUIController();
  const [anchor, setAnchor] = useState(null);
  const { pathname } = useLocation();
  const { user, role } = useAuth();
  const {
    notifications,
    unreadCount,
    loading,
    error,
    markNotificationAsRead,
    markAllNotificationsAsRead,
    retryNotifications,
  } = useNotification();
  const pageName =
    routes.find((route) => route.route === pathname)?.name || "Admin Portal";
  function openNotifications(event) {
    setAnchor(event.currentTarget);
  }
  return (
    <header className="admin-topbar">
      <div className="navbar-title">
        <strong>{pageName}</strong>
        <small>Fairsure · Admin & financial operations</small>
      </div>
      {!isMini && (
        <div className="topbar-actions">
          <IconButton
            className="mobile-menu"
            aria-label="Toggle navigation"
            onClick={() => setMiniSidenav(dispatch, !controller.miniSidenav)}
          >
            <FiMenu size={18} />
          </IconButton>
          <IconButton
            aria-label="Notifications"
            aria-haspopup="true"
            aria-expanded={Boolean(anchor)}
            onClick={openNotifications}
          >
            <Badge badgeContent={unreadCount} color="error" max={99}>
              <FiBell size={18} />
            </Badge>
          </IconButton>
          <Link
            to="/profile"
            aria-label="Account settings"
            className="account-link"
          >
            <span className="user-avatar">
              <FiUser size={16} />
            </span>
            <span>
              <strong>{user?.firstName || "Admin"}</strong>
              <small>{role}</small>
            </span>
          </Link>
        </div>
      )}
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        PaperProps={{
          sx: { width: 380, maxWidth: "calc(100vw - 32px)", maxHeight: 420 },
        }}
      >
        <div className="notification-heading">
          <strong>Notifications</strong>
          <button
            className="table-link"
            disabled={unreadCount === 0}
            onClick={markAllNotificationsAsRead}
          >
            Mark all as read
          </button>
        </div>
        {error && (
          <MenuItem onClick={retryNotifications}>{error} · Retry</MenuItem>
        )}
        {loading && !notifications.length && (
          <MenuItem>Loading notifications…</MenuItem>
        )}
        {!loading && !notifications.length && (
          <MenuItem>No notifications yet.</MenuItem>
        )}
        {notifications.map((item) => (
          <MenuItem
            key={item.id}
            onClick={async () => {
              await markNotificationAsRead(item.id);
              setAnchor(null);
            }}
            sx={{
              whiteSpace: "normal",
              gap: 1.5,
              alignItems: "flex-start",
              background: item.read ? "white" : "#f0fdf4",
            }}
          >
            {item.type === "NEW_MERCHANT_REGISTERED" ? (
              <FiUsers size={18} />
            ) : (
              <FiBell size={18} />
            )}
            <div className="notification-copy">
              <strong>{item.title || "Notification"}</strong>
              <p>{item.message}</p>
              <small>
                {item.createdAt
                  ? new Date(item.createdAt).toLocaleString("en-NG", {
                      timeZone: "Africa/Lagos",
                    })
                  : "Just now"}
              </small>
            </div>
          </MenuItem>
        ))}
      </Menu>
    </header>
  );
}
